<template>
    <div>
        <ViewItemTypeGroup  v-if="!!item" @success="alertSuccess"></ViewItemTypeGroup>

        <ItemTypeGroupTable
            title="Users"
            @addHealth="showModal"
            ref="table"
        ></ItemTypeGroupTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ItemTypeGroupTable from './ItemTypeGroupTable'
import ViewItemTypeGroup from './ViewItemTypeGroup'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'ItemTypeGroup',
    mixins: [popupMixins, permissionsMixins],
    components: {
        ItemTypeGroupTable,
        ViewItemTypeGroup,
    },
    data: () => {
        return {
            item: null,
        }
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
